import { MainButton, Typography } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useMemo } from 'react'
import i18n from '../../../i18n/i18next'
import { useRouteGuardContext } from '../../../state/routeGuardProvider'
import { useScreenTypeContext } from '../../state/screenTypeProvider'
import { useObjectContext } from '../providers/objectProvider'
interface IProviderButton {
    providerData: any
}

export const ProviderButton = ({ providerData }: IProviderButton) => {
    const { isAllowed } = useRouteGuardContext()
    const { screenType } = useScreenTypeContext()
    const { _id } = useObjectContext()

    const hasProvider = useMemo(() => {
        const canEdit = isAllowed(['allowedEdit'])
        if (providerData && canEdit) {
            return true
        }
        return false
    }, [providerData, isAllowed])

    if (!hasProvider) {
        return null
    }
    if (screenType !== 'upNext') return null

    const path = () => {
        return '/edit/hotelbooking/manage/' + _id
    }
    return (
        <Stack
            direction={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}
        >
            <Typography variant="bodyBold">
                {i18n.t('booking.manageYourBookings')}
            </Typography>
            <MainButton
                id={_id + 'providerButton'}
                icon="Leave_App"
                size="small"
                onClick={() => {
                    window.pushPath(path())
                }}
            />
        </Stack>
    )
}
